<template>
  <div id="app">
    <Layout>
    <Header :class="$style.layout_header">
      <PageHeader/>
    </Header>
    <Content :style="{margin: '20px 20px 20px 20px', minHeight: '570px'}">
      <router-view id="root_view"/>
    </Content>
    <Footer :class="$style.layout_footer">
      <PageFooter/>
    </Footer>
    </Layout>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import PageFooter from '@/components/PageFooter'
export default {
  name: 'App',
  components: {
    PageHeader,
    PageFooter
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  display: flex;
  flex-direction: column;
}
</style>

<style module>
  .layout_header {
    background-color: transparent;
    border: 0;
  }
  .layout_footer {
    background-color: #a8daf1;
    border: 0;
    bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue